export default function Problema() {
  return (
    <section className="relative py-16 md:py-32 overflow-hidden">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] md:w-[1000px] h-[400px] md:h-[600px] bg-neon-blue/10 rounded-full blur-[100px] md:blur-[150px]"></div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-10 md:mb-16 space-y-4 md:space-y-6">
            <div className="inline-flex items-center gap-2 px-3 md:px-4 py-2 rounded-full bg-red-500/10 border border-red-500/30 backdrop-blur-sm">
              <i className="ri-error-warning-fill text-red-400 text-sm md:text-base"></i>
              <span className="text-red-400 text-xs md:text-sm font-semibold tracking-wide">O PROBLEMA</span>
            </div>

            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-white leading-tight max-w-4xl mx-auto px-4">
              As Escolas Estão Preparando Seu Filho Para Um Mundo
              <span className="block bg-gradient-to-r from-red-400 to-orange-400 bg-clip-text text-transparent mt-2"> Que Não Existe Mais</span>
            </h2>

            <p className="text-base md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed px-4">
              Enquanto o mundo avança em velocidade exponencial, o sistema educacional continua preso no século passado.
            </p>
          </div>

          {/* Comparison Image */}
          <div className="relative mb-10 md:mb-16">
            {/* Labels - Floating Above */}
            <div className="absolute -top-12 md:-top-14 left-4 md:left-8 z-10">
              <p className="text-gray-400 font-bold text-sm md:text-lg">Escola Tradicional</p>
              <p className="text-gray-500 text-xs md:text-sm">Presa no passado</p>
            </div>
            <div className="absolute -top-12 md:-top-14 right-4 md:right-8 z-10 text-right">
              <p className="text-neon-blue font-bold text-sm md:text-lg">Freedom School</p>
              <p className="text-neon-blue/80 text-xs md:text-sm">A escola do futuro</p>
            </div>

            <div className="rounded-2xl md:rounded-3xl overflow-hidden border border-neon-blue/30 shadow-[0_0_50px_rgba(0,212,255,0.3)] md:shadow-[0_0_80px_rgba(0,212,255,0.3)]">
              <img 
                src="https://static.readdy.ai/image/9dca404c9b2236a1a1235bd6ca7530fb/45aa358ecb0186e9bdabab027e11ff7f.jpeg"
                alt="Comparação: Escola Tradicional vs Freedom School"
                className="w-full h-auto object-cover object-top"
              />
            </div>
          </div>

          {/* Problem Points Title */}
          <div className="text-center mb-8 md:mb-10">
            <h3 className="text-2xl md:text-3xl font-bold text-white">
              A Escola Tradicional Está Ultrapassada 
e Não Prepara Seu Filho Pro Futuro!
            </h3>
          </div>

          {/* Explanatory Text */}
          <div className="max-w-4xl mx-auto mb-10 md:mb-16 px-4">
            <div className="bg-dark-800/30 backdrop-blur-sm border border-gray-700/50 rounded-2xl p-6 md:p-10 space-y-6">
              <p className="text-sm md:text-base text-gray-300 leading-relaxed">
                Por que você botou seu filho na escola? Pouca gente de fato se fez essa pergunta, e colocou seu filho na escola tradicional sem nem pensar: porque é obrigado, porque sempre foi assim, porque essa é a única forma de prepará-lo para a vida.
              </p>
              
              <p className="text-sm md:text-base text-gray-300 leading-relaxed">
                Aí eu pergunto: o que significa prepará-lo para a vida? Ensinar a ganhar dinheiro? Ensinar a desenvolver a criatividade e a inteligência? Preparar ele para as demandas do futuro, para ser capaz de resolver problemas e dominar habilidades valiosas? Será que, de fato, a escola ensina isso? Que horas? Em que momento? Em qual matéria?
              </p>
              
              <p className="text-sm md:text-base text-gray-300 leading-relaxed">
                É óbvio que a escola não desenvolve a criatividade nem a inteligência, e muito menos prepara o seu filho para o futuro. A única coisa que ela faz é ensinar inúmeros conteúdos padronizados, fora do contexto da criança, e forçar ela a decorar para fazer uma prova — mesmo que esqueça tudo dois meses depois. Sem falar que seu filho jamais usará esse conteúdo para nada em sua vida, a não ser para passar no vestibular, aprender uma profissão e, muito lá na frente, virar empregado de alguma empresa, ganhando sempre menos que o dono do negócio.
              </p>
              
              <p className="text-sm md:text-base text-gray-300 leading-relaxed">
                É óbvio que esse modelo já funcionou muito no passado, mas, a cada ano que passa, ele mostra mais sinais de esgotamento — principalmente depois do advento da inteligência artificial, que tornará obsoletos a maioria dos empregos que existem hoje em dia. E, se a escola só prepara seu filho para um emprego, quando ele chegar lá, com toda certeza esse emprego não vai mais existir.
              </p>
              
              <div className="pt-4 border-t border-neon-blue/20">
                <p className="text-sm md:text-base text-white leading-relaxed font-medium">
                  Por isso nasceu a <span className="text-neon-blue font-bold">Freedom School</span>: uma escola completamente disruptiva, criada para substituir totalmente a escola tradicional, focada em treinar o que realmente importa — as maiores habilidades do futuro — para preparar seu filho para ser o dono da empresa, e não um funcionário, e para ganhar dinheiro muito antes mesmo de virar adulto.
                </p>
              </div>
              
              <p className="text-sm md:text-base text-gray-300 leading-relaxed">
                E, para quem não tem coragem de abandonar completamente a escola tradicional, nós estamos lançando nosso curso de férias, o <span className="text-neon-blue font-semibold">Freedom Experience</span>: um curso intensivo de 3 semanas, onde vamos ensinar habilidades incríveis que vão mudar completamente a rota do seu filho.
              </p>
            </div>
          </div>

          {/* Problem Points */}
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            <div className="bg-dark-800/50 backdrop-blur-sm border border-red-400/20 rounded-xl md:rounded-2xl p-6 md:p-8 space-y-3 md:space-y-4">
              <div className="w-12 h-12 md:w-16 md:h-16 bg-red-500/10 rounded-lg md:rounded-xl flex items-center justify-center">
                <i className="ri-time-fill text-2xl md:text-3xl text-red-400"></i>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-white">Conteúdo Desatualizado</h3>
              <p className="text-sm md:text-base text-gray-300 leading-relaxed">
                Enquanto a IA revoluciona o mundo, as escolas ainda ensinam da mesma forma há décadas.
              </p>
            </div>

            <div className="bg-dark-800/50 backdrop-blur-sm border border-red-400/20 rounded-xl md:rounded-2xl p-6 md:p-8 space-y-3 md:space-y-4">
              <div className="w-12 h-12 md:w-16 md:h-16 bg-red-500/10 rounded-lg md:rounded-xl flex items-center justify-center">
                <i className="ri-speed-fill text-2xl md:text-3xl text-red-400"></i>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-white">Aprendizado Lento</h3>
              <p className="text-sm md:text-base text-gray-300 leading-relaxed">
                Métodos ultrapassados que não aproveitam o potencial da tecnologia moderna.
              </p>
            </div>

            <div className="bg-dark-800/50 backdrop-blur-sm border border-red-400/20 rounded-xl md:rounded-2xl p-6 md:p-8 space-y-3 md:space-y-4">
              <div className="w-12 h-12 md:w-16 md:h-16 bg-red-500/10 rounded-lg md:rounded-xl flex items-center justify-center">
                <i className="ri-forbid-fill text-2xl md:text-3xl text-red-400"></i>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-white">Sem Habilidades Reais</h3>
              <p className="text-sm md:text-base text-gray-300 leading-relaxed">
                Não preparam para as profissões do futuro que já existem hoje.
              </p>
            </div>

            <div className="bg-dark-800/50 backdrop-blur-sm border border-red-400/20 rounded-xl md:rounded-2xl p-6 md:p-8 space-y-3 md:space-y-4">
              <div className="w-12 h-12 md:w-16 md:h-16 bg-red-500/10 rounded-lg md:rounded-xl flex items-center justify-center">
                <i className="ri-book-2-fill text-2xl md:text-3xl text-red-400"></i>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-white">Matérias Sem Utilidade</h3>
              <p className="text-sm md:text-base text-gray-300 leading-relaxed">
                Foco apenas em português, geografia e história sem aplicação prática. A criança aprende na marra, sem interesse real.
              </p>
            </div>
          </div>

          {/* Solution Highlight */}
          <div className="mt-10 md:mt-16 bg-gradient-to-r from-neon-blue/10 to-neon-purple/10 backdrop-blur-sm border border-neon-blue/30 rounded-2xl md:rounded-3xl p-8 md:p-12 text-center">
            <i className="ri-lightbulb-flash-fill text-4xl md:text-6xl text-neon-blue mb-4 md:mb-6"></i>
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-3 md:mb-4 px-4">
              É Por Isso Que Criamos a Freedom School
            </h3>
            <p className="text-base md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed px-4">
              Uma escola que ensina as habilidades que realmente importam: <strong className="text-neon-blue">dominar a inteligência artificial, empreender, inovar, pensar por si mesmo, ganhar dinheiro e muito mais</strong>.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
